import { create } from "zustand";
import { createStoreWithSelectors } from "./createStoreWithSelectors";

interface ParkOptInState {
  email: boolean;
  phone: boolean;
  SMS: boolean;
  post: boolean;
  setEmail: (email: boolean) => void;
  setPhone: (phone: boolean) => void;
  setSMS: (SMS: boolean) => void;
  setPost: (post: boolean) => void;
}

const parkOptInInitialValues = {
  email: false,
  phone: false,
  SMS: false,
  post: false,
};

const parkOptInStore = create<ParkOptInState>()((set) => ({
  ...parkOptInInitialValues,
  setEmail: (email) => set(() => ({ email })),
  setPhone: (phone) => set(() => ({ phone })),
  setSMS: (SMS) => set(() => ({ SMS })),
  setPost: (post) => set(() => ({ post })),
}));

export const useParkOptInStore = createStoreWithSelectors(parkOptInStore);
